import * as React from "react";
import { Suspense } from "react";
import Helmet from "react-helmet";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { CountryProvider } from "./Contexts/CountryContext";
import { FeedbackProvider } from "./Contexts/FeedbackContext";
import { HostProvider } from "./Contexts/HostContext";
import { WebpushProvider } from "./Contexts/WebpushContext";
import MobileFooter from "./Footer/MobileFooter";
import { PageFooter } from "./Footer/PageFooter";
import { HeaderSelector } from "./Header/HeaderSelector";
import ScrollToTop from "./Helper/ScrollToTop";
import HostLoader from "./Host/HostLoader";
import InstructionBox from "./InstructionBox/InstructionBox";
import CountryReducer from "./Reducers/CountryReducer";
import FeedbackReducer from "./Reducers/FeedbackReducer";
import HostReducer from "./Reducers/HostReducer";
import StickyHeader from "./StickyHeader";
import TopMenu from "./TopMenu";
import { IntlProvider } from "react-intl";
import KitHomeHeader from "./WebmasterKit/KitHomeHeader";
import ChatLoader from "./Chat/ChatLoader";
var NotFoundPage = /*#__PURE__*/React.lazy(function () {
  return import("./NotFoundPage");
});
var Page = /*#__PURE__*/React.lazy(function () {
  return import("./Page");
});
var Survey = /*#__PURE__*/React.lazy(function () {
  return import("./Survey/Survey");
});
var Profile = /*#__PURE__*/React.lazy(function () {
  return import("./ProfilePage/Profile");
});
var Agb = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/AGB/agb");
});
var Datenschutz = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Datenschutz/Datenschutz");
});
var Datenschutz201901 = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Datenschutz/Datenschutz201901");
});
var Datenschutz201805 = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Datenschutz/Datenschutz201805");
});
var Impressum = /*#__PURE__*/React.lazy(function () {
  return import("./Pages/Impressum/Impressum");
});
var Category = /*#__PURE__*/React.lazy(function () {
  return import("./Category/Category");
});
var PhonesexPage = /*#__PURE__*/React.lazy(function () {
  return import("./Phonesex/PhonesexPage");
});
var FeedbackDisplay = /*#__PURE__*/React.lazy(function () {
  return import("./Feedback/FeedbackDisplay");
});
var Livecam = /*#__PURE__*/React.lazy(function () {
  return import("./Livecam/Livecam");
});
var Kaufvideos = /*#__PURE__*/React.lazy(function () {
  return import("./Kaufvideos/Kaufvideos");
});
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
if (!Intl.PluralRules) {
  require("@formatjs/intl-pluralrules/polyfill");
  require("@formatjs/intl-pluralrules/locale-data/de"); // Add locale data for de
}
// @ts-ignore
if (!Intl.RelativeTimeFormat) {
  require("@formatjs/intl-relativetimeformat/polyfill");
  require("@formatjs/intl-relativetimeformat/locale-data/de"); // Add locale data for de
}
function App() {
  var DebugLocation = function () {
    var location = useLocation();
    console.log("Aktuelle URL:", location.pathname);
    return null;
  };
  var home = window.layoutSettings.seo.home;
  function EnforceTrailingSlash() {
    var location = useLocation();
    var navigate = useNavigate();
    useEffect(function () {
      if (location.pathname.match(/^[^?#]*[^\/]$/)) {
        navigate(location.pathname + "/", {
          replace: true
        });
      }
    }, [location, navigate]);
    return null;
  }
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: "de",
    messages: window.languageData
  }, /*#__PURE__*/React.createElement(CountryProvider, {
    reducer: CountryReducer
  }, /*#__PURE__*/React.createElement(HostProvider, {
    reducer: HostReducer
  }, /*#__PURE__*/React.createElement(FeedbackProvider, {
    reducer: FeedbackReducer
  }, /*#__PURE__*/React.createElement(Router, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, home.meta.title), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: home.meta.description
  })), /*#__PURE__*/React.createElement(ScrollToTop, null), /*#__PURE__*/React.createElement(HeaderSelector, null), /*#__PURE__*/React.createElement(TopMenu, null), /*#__PURE__*/React.createElement(KitHomeHeader, null), /*#__PURE__*/React.createElement(InstructionBox, null), /*#__PURE__*/React.createElement(WebpushProvider, null, /*#__PURE__*/React.createElement(HostLoader, null), /*#__PURE__*/React.createElement(DebugLocation, null), /*#__PURE__*/React.createElement(EnforceTrailingSlash, null), /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    path: "/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      })
    }, /*#__PURE__*/React.createElement(Page, {
      canIndex: window.index.home,
      title: home.meta.title,
      description: home.meta.description
    }))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/welcome/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      })
    }, /*#__PURE__*/React.createElement(Page, {
      canIndex: window.index.home,
      title: home.meta.title,
      description: home.meta.description
    }))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/seite/:page/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      })
    }, /*#__PURE__*/React.createElement(Page, {
      canIndex: false,
      title: home.meta.title,
      description: home.meta.description
    }))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/agb/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Agb, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/imprint/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Impressum, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Datenschutz, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz201901/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Datenschutz201901, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/page/datenschutz201805/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Datenschutz201805, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/profil/:name/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Profile, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/kategorie/:category/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Category, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/telefonsex/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(PhonesexPage, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/chatcam/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Livecam, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/kaufvideos/",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(Kaufvideos, null))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Telefonsex",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: "/telefonsex/",
      replace: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Telefonsex/",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: "/telefonsex/",
      replace: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Chat-Cam",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: "/chatcam/",
      replace: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Chat-Cam/",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: "/chatcam/",
      replace: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Kaufvideos",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: "/kaufvideos/",
      replace: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/de/Kaufvideos/",
    element: /*#__PURE__*/React.createElement(Navigate, {
      to: "/kaufvideos/",
      replace: true
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(Suspense, {
      fallback: /*#__PURE__*/React.createElement("div", {
        style: {
          height: "750px"
        }
      }, "Lade Seite...")
    }, /*#__PURE__*/React.createElement(NotFoundPage, null))
  })), /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Survey, null))), /*#__PURE__*/React.createElement(StickyHeader, null), /*#__PURE__*/React.createElement(MobileFooter, null), /*#__PURE__*/React.createElement(PageFooter, null)), /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(FeedbackDisplay, null)), /*#__PURE__*/React.createElement(ChatLoader, null)))));
}
export default App;